import { createFileRoute } from "@tanstack/react-router";
import {
  founderPersonJsonLd,
  landingOrganizationJsonLd,
  landingPageJsonLd,
  landingRouteHead,
} from "@/lib/landing-seo";
import { jsonLdScript } from "@/lib/marketing-jsonld";
import { EmailLanding } from "@/components/landing/EmailLanding";
import "@/styles/landing-story.css";
import "@/styles/email-landing.css";

export const Route = createFileRoute("/_home/")({
  ssr: true, // public SEO route (D-216-5)
  head: landingRouteHead,
  component: LandingPage,
});

function LandingPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdScript(landingPageJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: jsonLdScript(landingOrganizationJsonLd),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdScript(founderPersonJsonLd) }}
      />
      <EmailLanding />
    </>
  );
}
